<template>
  <view-panel title="用户实时行为" class="realtime-behaviours">
    <span slot="title">
      <c-input
        class="name-filter"
        icon="cicon-search"
        v-model="search"
        :width="131"
        placeholder="用户名/用户ID"
        @input="onSearch"
      />
      <span style="font-size: 14px;float: right">
        忽略
        <c-selector
          v-if="ready"
          :store="eventList"
          multiple
          showCount
          filterOption
          keyField="event_id"
          labelField="event_name"
          aliasField="alias_name"
          placeholder="选择事件"
          v-model="ignoreList"
          @change="onChangeIgnores"
        ></c-selector>
      </span>
    </span>
    <div class="to-grid" ref="grid">
      <c-data-grid :store="showStore">
        <c-grid-column title="时间" :width="80" field="time"></c-grid-column>
        <c-grid-column title="用户名" field="name">
          <template slot-scope="data" slot="header">
            {{ data.title
            }}<c-tooltip content="对应系统属性中的诸葛id或identify id">
              <i class="cicon-help"></i>
            </c-tooltip>
          </template>
          <c-tooltip slot-scope="{ data }" :content="data.name">
            <span>{{ splitStr(data.name) }}</span>
          </c-tooltip>
        </c-grid-column>
        <c-grid-column
          title="实名/匿名"
          :width="100"
          field="identify"
        ></c-grid-column>
        <c-grid-column title="平台" :width="80" field="plat"></c-grid-column>
        <c-grid-column title="触发行为" field="event">
          <c-tooltip slot-scope="{ data }" :content="data.event">
            <span>{{ splitStr(data.event) }}</span>
          </c-tooltip>
        </c-grid-column>
      </c-data-grid>
    </div>
  </view-panel>
</template>
<script>
import viewPanel from './panel'
import { util } from '../../utils'
import { actions } from '../../store/constants'
import { mapState } from 'vuex'
export default {
  name: 'overviewRealtimeBehaviours',
  components: {
    viewPanel
  },
  data () {
    return {
      store: [],
      ignoreList: [],
      search: ''
    }
  },
  computed: {
    showStore () {
      const ids = this.ignoreList.map(event => event.event_id)
      return this.store.filter(row => {
        return (
          new RegExp(this.search).test(row.name) &&
          !ids.includes(Number(row.eventId))
        )
      })
    },
    ...mapState({
      eventList (state) {
        return state.bizSys.eventList
      },
      ready (state) {
        return state.bizSys.ready.eventGroups && state.bizDataview.ready.ignores
      }
    })
  },
  beforeMount () {
    this.$store
      .dispatch(actions.dataview.getIgnoreConfig, this.appId)
      .then(res => {
        this.ignoreList = (res.data || []).map(id => {
          return { event_id: id }
        })
      })
    this.$store
      .dispatch(actions.biz.sys.queryEventMeta, {
        appId: this.appId,
        platform: this.platform
      })
      .catch(err => {
        if (err.__CANCEL__) return
        console.error(err)
      })
  },
  methods: {
    receiveEvent (event) {
      this.store.unshift({
        time: util.timeFormat(new Date(Number(event.datetime))),
        name: event.u_name || event.zg_id,
        identify: event.is_anonymous ? '匿名' : '实名',
        plat: event.pl,
        event: event.event_name,
        eventId: event.event_id
      })
      if (this.store.length > 1000) {
        this.store.pop()
      }
      this.$nextTick(() => {
        const grid = this.$refs.grid
        grid.scrollTop = 0
      })
    },
    onSearch (val) {
      this.$emit('search', val)
    },
    onChangeIgnores (ignores) {
      this.$emit('ignore', ignores.map(event => event.event_id))
    },
    splitStr (str) {
      return util.strMiddleSplit(str, {
        maxLength: 15,
        beginLength: 7,
        endLength: 7,
        replaceStr: '...'
      })
    },
    reset () {
      this.store = []
    }
  }
}
</script>
<style lang="sass">
@import '../../assets/constants'
.realtime-behaviours
  height: auto!important
  .name-filter
    margin-left: 10px
    height: 28px !important
    line-height: 28px !important
  .c-drop-panel
    max-height: none !important
  .to-grid
    // height: auto
    height: 280px
    margin-top: 7px
    overflow: auto
    .c-data-grid
      border: none
      min-height: 100%
      .c-grid-empty
        line-height: 250px
      .c-grid-header-cell
        background: #FAFAFA
        border: none
        color: #75787D
        text-align: center
        &:first-of-type
          text-align: left !important
        i
          color: $color-brand
          margin-left: 5px
      .c-grid-cell
        border: none
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        text-align: center
        &:first-of-type
          text-align: left !important
</style>
